
  import Vue from "vue";
  import { Component } from "vue-property-decorator";

  @Component
  export default class Cabecalho extends Vue {
    mounted() {
      this.alturaCabecalho();
    }
    // ENVIAR PARA O TOPO DA PÁGINA
    scrollToTop() {
      window.scrollTo(0, 0);
    }
    alturaCabecalho() {
      let cabecalho = this.$refs.cabecalho as any;
      let height = cabecalho.clientHeight;
      // debugger;
      this.$store.commit("alturaCabecalho", {
        alturaCabecalho: height
      });
    }
  }
